import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_APP_CONFIG } from '../apollo/queries/appConfig';
import { DEFAULT_APP_VAT_PERCENTAGE } from '../constants/appConfigDefaults';

function commaSeparatedToArray(str: string): string[] {
    return str
        ? str
              .split(',')
              .map(s => s.trim())
              .filter(Boolean)
        : [];
}

export function useAppConfig() {
    const { data, loading } = useQuery(GET_APP_CONFIG);

    const config = useMemo(() => {
        const appConfig = data?.appConfig;
        return {
            vatPercentage:
                appConfig?.vatPercentage ?? DEFAULT_APP_VAT_PERCENTAGE,
            pricingBatchesModuleEnabled:
                appConfig?.pricingBatchesModuleEnabled ?? false,
            trainingModuleEnabled: appConfig?.trainingModuleEnabled ?? false,
            dmOpsDeclineReasons: commaSeparatedToArray(
                appConfig?.dmOpsDeclineReasons ?? '',
            ),
            procurementDeclineReasons: commaSeparatedToArray(
                appConfig?.procurementDeclineReasons ?? '',
            ),
            supplierDeclineReasons: commaSeparatedToArray(
                appConfig?.supplierDeclineReasons ?? '',
            ),
            interimPriceReasons: commaSeparatedToArray(
                appConfig?.interimPriceReasons ?? '',
            ),
            financialYearStartMonth: appConfig?.financialYearStartMonth ?? 7,
            salesDataMaintenanceStartTime:
                appConfig?.salesDataMaintenanceStartTime ?? null,
            salesDataMaintenanceEndTime:
                appConfig?.salesDataMaintenanceEndTime ?? null,
            salesDataMaintenanceIsActive:
                appConfig?.salesDataMaintenanceIsActive ?? false,
            salesDataMaintenanceEndsAt:
                appConfig?.salesDataMaintenanceEndsAt ?? null,
        };
    }, [data]);

    return { ...config, loading };
}
